import React from "react";
import { Link } from 'react-router-dom';
import './Book.scss';
import { API_BASE_URL } from '../../config';
import { formatDate, sameDay } from '../../utils/dates';

function absoluteUrl(path) {
    if (!path) return '';
    if (/^https?:/i.test(path)) return path;
    return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}

export default function Book({
    id,
    title,
    author,
    displayAuthor,
    is_published,
    coverImage,
    categoryLabel,
    avgRating,
    ratingCount,
    viewCount,
    publishedAt,
    updatedAt,
    to = '/writing',
    showBadge = true,
}) {
    const shownAuthor = displayAuthor || author;
    const cover = absoluteUrl(coverImage);

    return (
        <Link to={to} state={{ book_id: id }} className='book-card'>
            <div className={'book-cover' + (cover ? ' has-image' : '')}>
                {cover ? (
                    <img src={cover} alt={title || 'غلاف'} className='book-cover-img' loading='lazy' />
                ) : (
                    <>
                        <span className='book-cover-title'>{title || 'بدون عنوان'}</span>
                        <span className='book-cover-author'>{shownAuthor}</span>
                    </>
                )}
                {categoryLabel && <span className='book-cover-category'>{categoryLabel}</span>}
            </div>
            <div className='book-meta'>
                <span className='book-title' title={title}>{title || 'بدون عنوان'}</span>
                {showBadge && (
                    <span className={'book-badge ' + (is_published ? 'book-badge--published' : 'book-badge--draft')}>
                        {is_published ? 'منشور' : 'مسودة'}
                    </span>
                )}
            </div>
            <div className='book-author'>{shownAuthor}</div>
            {(publishedAt || updatedAt) && (
                <div className='book-dates'>
                    {publishedAt && <span>نُشر {formatDate(publishedAt)}</span>}
                    {updatedAt && !sameDay(publishedAt, updatedAt) && (
                        <span>{publishedAt ? 'حُدّث' : 'آخر تعديل'} {formatDate(updatedAt)}</span>
                    )}
                </div>
            )}
            {(avgRating || viewCount != null) && (
                <div className='book-stats'>
                    {avgRating
                        ? <span>★ {avgRating} ({ratingCount ?? 0})</span>
                        : <span className='book-stats--muted'>★ —</span>}
                    {viewCount != null && (
                        <span className='book-stats--muted'>
                            {(viewCount).toLocaleString('ar-EG')} مشاهدة
                        </span>
                    )}
                </div>
            )}
        </Link>
    );
}
